import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export const Portal = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/auth");
  }, []);
  return <div />;
};
